// Redirect all discussion urls to folio.procreate.com

export default (req, res, next) => {
    res.writeHead(301, { Location: `https://folio.procreate.com${req.originalUrl}` });
    res.end();

    return;
};
